<div
  class="mam-media-card"
  cdkDrag
  [cdkDragData]="item"
  [cdkDragDisabled]="!canAddToTimeline"
>
  <div class="mam-media-card__thumbnail">
    <img
      *ngIf="item.thumbnailUrl"
      [src]="item.thumbnailUrl"
      [alt]="item.title"
      class="mam-media-card__img"
      loading="lazy"
    />
    <div *ngIf="!item.thumbnailUrl" class="mam-media-card__placeholder">
      <span class="mam-media-card__placeholder-text">VIDEO</span>
    </div>
    <span *ngIf="item.durationFormatted" class="mam-media-card__duration">{{ item.durationFormatted }}</span>
  </div>
  <div class="mam-media-card__info">
    <div class="mam-media-card__title">{{ item.title }}</div>
    <div class="mam-media-card__duration-inline" *ngIf="item.durationFormatted">{{ item.durationFormatted }}</div>
  </div>
  <button
    type="button"
    class="mam-media-card__add-btn"
    aria-label="Add to timeline"
    title="Add to timeline"
    [disabled]="!canAddToTimeline"
    (click)="canAddToTimeline && addToTimeline.emit(item)"
  >
    <span class="mam-media-card__add-icon">+</span>
  </button>
</div>
